import { Box, Button, Dialog, useTheme } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import CloseModalButton from '../../../../components/CloseModalButton';
import { StyledDialogContent, StyledDialogFooter, StyledDialogTitle } from '../../../../components/Dialog.styled';

type Props = {
  open: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
};

const ExpiredConfirmationModal: React.FC<Props> = ({ open, handleClose, handleSubmit }) => {
  const theme = useTheme();

  return (
    <Dialog maxWidth="sm" open={open} onClose={handleClose}>
      <CloseModalButton handleClose={handleClose} />
      <StyledDialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', color: theme.palette.warning.main, mr: 1 }} component="span">
            <WarningIcon />
          </Box>
          Expired Item
        </Box>
      </StyledDialogTitle>
      <StyledDialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          This item has expired. In order to stay compliant and prepared for an emergency, we strongly recommend you replace this item now. Are you
          sure you want to continue?
        </Box>
      </StyledDialogContent>
      <StyledDialogFooter>
        <Button variant="outlined" onClick={handleClose}>
          No
        </Button>
        <Button onClick={() => handleSubmit()} variant="contained">
          Yes
        </Button>
      </StyledDialogFooter>
    </Dialog>
  );
};

export default ExpiredConfirmationModal;
